// The one merged grant map this portal evaluates — extracted from main.tsx so
// SessionProvider (affordance gates) and nav.ts (the sidebar) read the SAME
// matrix. Two copies could drift into a sidebar that offers a screen the gates
// then hide, or vice versa.
//
// Key-wise union, never a spread (a spread would clobber owner/admin's core:*
// with lib:*/cms:*). useCan is UI sugar; the API stays the only authority.
import { mergeGrants, ROLE_GRANTS } from "@erp/auth-kit/rbac";
import { LIB_GRANTS } from "@erp/module-lib/schemas";
import { CMS_GRANTS } from "@erp/module-cms/schemas";
import { FIN_GRANTS } from "@erp/module-fin/schemas";
import { AUDIT_GRANTS } from "@erp/module-audit/schemas";

export const GRANTS = mergeGrants(ROLE_GRANTS, LIB_GRANTS, CMS_GRANTS, FIN_GRANTS, AUDIT_GRANTS);
